export const QUERY_PARAM_PAGE_ID_FOR_PUBLIC_TEMPLATE =
  'pageIdForPublicTemplate';

export const QUERY_PARAM_IS_DUPLICATE_PUBLIC_TEMPLATE_TO_DEFAULT_FOLDER =
  'isDuplicatePublicTemplateToDefaultFolder';
